<template>
  <div class="locator-map">
    <div class="search-map">
      <stSelect ref="search" :options="eventcards"/>
    </div>
    <div class="tooltip"></div>
  </div>
</template>

<script>
import {mapState} from 'vuex'
import mapboxgl from 'mapbox-gl'
import 'mapbox-gl/dist/mapbox-gl.css'
import stSelect from './stSelect.vue'
import _find from 'lodash/find'
import {SINGAPORE, layerIconGeojsonTemplate} from './variables.js'

export default {
  props: ['attributes'],
  computed: mapState(['sections']),
  components: {
    stSelect
  },
  data () {
    return {
      iconLayers: [],
      selectedIconLayer: null,
      eventcards: []
    }
  },
  methods: {
    getData: function () {
      const component = _find(this.sections[0].components, {type: 'eventcards'})
      component.value.forEach(element => {
        this.eventcards.push(element.value)
      })
    }
  },
  mounted () {
    this.getData()
    const map = new mapboxgl.Map(Object.assign({
      container: this.$el,
      style: 'mapbox://styles/chachopazos/ck3fc0qpp0fyd1ct5ai5owqu0',
      minZoom: 10,
      maxZoom: 16,
      maxBounds: [[103.42295489648154, 1.0774867904165433], [104.21671710351262, 1.6266481512753188]],
      scrollZoom: false,
      dragPan: false,
      dragRotate: false,
      accessToken: 'pk.eyJ1IjoiY2hhY2hvcGF6b3MiLCJhIjoiY2pkMDN3eW4wNHkwZDJ5bGc0cnpueGNxbCJ9.WWWg_OnK5e7L1RknMliY4A'
    }, SINGAPORE))
    map.touchZoomRotate.disableRotation()

    this.$watch('$window.innerWidth', w => {
      if (w >= 768) map.dragPan.enable()
      else map.dragPan.disable()
    }, {immediate: true})

    const nav = new mapboxgl.NavigationControl({showCompass: false})
    map.addControl(nav, 'top-left')

    // const marker = new mapboxgl.Marker()

    map.on('load', () => {
      map.addSource('ge-boundaries', {
        type: 'vector',
        url: 'mapbox://chachopazos.ge-boundaries-new'
      })

      map.addLayer({
        id: 'ge-boundaries_fill',
        source: 'ge-boundaries',
        'source-layer': 'ge-boundaries-2020',
        type: 'fill',
        paint: {
          'fill-color': ['match',
            ['get', 'grc'],
            'SMC', 'rgba(25, 45, 86, 0.2)',
            '3-Member GRC', 'rgba(25, 45, 86, 0.1)',
            '4-Member GRC', 'rgba(25, 45, 86, 0.35)',
            '5-Member GRC', 'rgba(25, 45, 86, 0.60)',
            '6-Member GRC', 'rgba(25, 45, 86, 0.8)',
            'white'
          ],
          'fill-opacity': 0.9
        }
      })

      map.addLayer({
        id: 'ge-boundaries_outline',
        source: 'ge-boundaries',
        'source-layer': 'ge-boundaries-2020',
        type: 'line',
        paint: {
          'line-color': 'white',
          'line-width': 1.2
        }
      })

      map.loadImage(
        'https://cdn0.iconfinder.com/data/icons/small-n-flat/24/678111-map-marker-512.png',
        function (error, image) {
          if (error) throw error
          map.addImage('event-icon', image)
        }
      )
    })

    this.$refs.search.$on('input', val => {
      if (val === null) {
        val = {constituency: null}
      }

      this.selectedIconLayer = 'eventpoints-' + val.constituency

      if (val.constituency !== null && !this.iconLayers.includes('eventpoints-' + val.constituency)) {
        const icons = JSON.parse(JSON.stringify(layerIconGeojsonTemplate)) // deep clone
        icons.id = 'eventpoints-' + val.constituency
        this.eventcards.forEach(function (item) {
          if (item.constituency === val.constituency) {
            const coor = item.coordinate.replace(' ', '').split(',')
            icons.source.data.features.push({
              'type': 'Feature',
              'geometry': {
                'type': 'Point',
                'coordinates': [+coor[0].trim(), +coor[1].trim()]
              },
              properties: {...item}
            })
          }
        })

        map.addLayer(icons)
        this.iconLayers.push('eventpoints-' + val.constituency)

        map.on('mousemove', 'eventpoints-' + val.constituency, (e) => {
          if (e.features.length > 0) {
            map.getCanvas().style.cursor = 'pointer'
          }
        })

        map.on('mouseleave', 'eventpoints-' + val.constituency, (e) => {
          map.getCanvas().style.cursor = ''
        })
      }

      this.iconLayers.forEach(function (layer) {
        map.setLayoutProperty(layer, 'visibility', 'none')
      })
      if (val.constituency !== null) {
        map.setLayoutProperty('eventpoints-' + val.constituency, 'visibility', 'visible')
      }
    })

    map.on('click', e => {
      if (!this.selectedIconLayer) return

      const features = map.queryRenderedFeatures(e.point, {
        layers: [this.selectedIconLayer]
      })
      if (features.length) {
        document.querySelector(`[id='${features[0].properties.coordinate}']`).scrollIntoView({behavior: 'smooth'})
      }
    })
  }
}

</script>

<style lang="scss">
.locator-map {
  width: 100%;
  height: 800px;

  .onemap-search {
    display: block;
    position: absolute;
    z-index: 1;
    top: 20px;
    right: 20px;
  }

  .tooltip {
    position: absolute;
  }

  .mapboxgl-canvas {
    outline: none;
  }

  .mapboxgl-marker svg g g:nth-child(2) {
    fill: $stblue;
  }

  .mapboxgl-popup-content {
    padding: 3px 8px;
    font-family: $font-CuratorRegular;
  }

  .mapboxgl-control-container {
    .mapboxgl-ctrl-bottom-left,
    .mapboxgl-ctrl-bottom-right {
      display: none;
    }
  }

  .mapboxgl-ctrl-group {
    margin: 50px 0 0 10px;
  }

  .search-map {
    position: relative;
    margin: 0 auto;
    width: 90%;
    max-width: 500px;
  }
}
</style>
